import { colors } from 'client/styles'

export function getScoreRange(
  score: number,
  neutral = false
): { level: 1 | 2 | 3 | 4 | 5; color: string } {
  const values = { higher: 8.5, high: 8, medium: 6.5, low: 5 }

  const green = 'var(--color--semantic--success--500)'

  if (score >= values.higher) {
    return { level: 1, color: green }
  }

  if (score >= values.high && score < values.higher) {
    return { level: 2, color: green }
  }

  if (score >= values.medium && score < values.high) {
    return { level: 3, color: green }
  }

  if (score >= values.low && score < values.medium) {
    return { level: 4, color: neutral ? 'var(--color--neutral--600)' : colors.orange }
  }

  return { level: 5, color: neutral ? 'var(--color--neutral--600)' : colors.red }
}
